/**
 * Borra un comentario de IG/FB via Meta Graph API directo.
 *
 * Operación IRREVERSIBLE. Meta no expone undo. Para DMs no existe equivalente
 * — el workaround sigue siendo mandar mensaje correctivo encima.
 *
 * (Conservamos el filename `use-hide-comment` por compat de imports — la
 * acción real ahora es delete, no hide.)
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiPost } from "@/lib/api";

interface DeleteCommentPayload {
  conversationId: string;
  messageId: number;
}

export function useDeleteComment() {
  const qc = useQueryClient();
  return useMutation<{ ok: boolean }, Error, DeleteCommentPayload>({
    mutationFn: async ({ conversationId, messageId }) =>
      apiPost<{ ok: boolean }>(`/conversations/${conversationId}/delete-comment`, {
        messageId,
      }),
    onSuccess: () => {
      // queryKey real es ["conversation-detail", id], no ["messages"].
      qc.invalidateQueries({ queryKey: ["conversations"] });
      qc.invalidateQueries({ queryKey: ["conversation-detail"] });
      toast.success("Comentario eliminado de la red");
    },
    onError: (err) => {
      toast.error(`No se pudo eliminar: ${err.message}`);
    },
  });
}

// Alias legacy para no romper imports anteriores. Migrar a useDeleteComment.
export const useHideComment = useDeleteComment;
